import { AddOnCharge } from '~hooks/useAddOns/models';
import { InvoiceLineItem } from '~hooks/useInvoiceLineItems/models';
import { Invoice } from '~hooks/useInvoices/models';

export class SettlementInvoiceLines {
  constructor(
    private _invoice: Invoice,
    private _line_items: InvoiceLineItem[],
    private _add_on_charges: AddOnCharge[],
  ) {}

  public get invoice() {
    return this._invoice;
  }

  public get lineItems() {
    return this._line_items;
  }

  public get addOnCharges() {
    return this._add_on_charges;
  }

  public get lineCount() {
    return this._line_items.length + this._add_on_charges.length;
  }

  public get hasEditableLine() {
    return [...this._line_items, ...this._add_on_charges].some(
      (line) => (line.editable ?? this._invoice.editable) === true,
    );
  }
}
